import RatgeberTemplate from "@/components/RatgeberTemplate";
import { getRatgeberBySlug } from "@/data/ratgeberData";
import Footer from "@/components/Footer";

const RatgeberVerdauung = () => {
  const content = getRatgeberBySlug("verdauungsprobleme");
  if (!content) return null;

  return (
    <>
      <RatgeberTemplate content={content} />
      <Footer />
    </>
  );
};

export default RatgeberVerdauung;
